

































import { Vue, Component } from 'vue-property-decorator'
import { $db } from '@/services/Db'
import Downloader from '@/components/Downloader.vue'
import BulkWhitelist from './BulkWhitelist.vue'

@Component({ components: { BulkWhitelist, Downloader }})
export default class SerialsPage extends Vue {

	searchString = ''
	loading = false
	serial = ''
	whitelistedSKU = ''
	licenses = []
	error = ''

	async search() {
		this.loading = true
		try {
			const res = await $db.query(`query SerialSearch($serial: String!) {
				serial(serial: $serial) {
					id SKU
				}
				licenses(appliedSerial: $serial) {
					id
					customer
					order_id
					SKU
					write_date
				}
			}`, { serial: this.searchString })
			this.serial = this.searchString
			this.whitelistedSKU = res.serial ? res.serial.SKU : ''
			this.licenses = res.licenses || []
		} catch(err) {
			this.error = err.message
		}
		this.loading = false
	}

}
